import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { PageLoading } from '@/components/ui/spinner';
import { isFirebaseConfigured } from '@/lib/firebase';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { loading, isAuthenticated, loggedOut } = useAuth();
  const location = useLocation();

  // In dev mode without Firebase, allow access if authenticated (auto-login handles this)
  if (import.meta.env.DEV && !isFirebaseConfigured()) {
    if (loading) {
      return <PageLoading />;
    }
    if (loggedOut || !isAuthenticated) {
      return (
        <Navigate
          to="/login"
          state={{ from: location.pathname + location.search + location.hash }}
          replace
        />
      );
    }
    return <>{children}</>;
  }

  if (loading) {
    return <PageLoading />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname + location.search + location.hash }}
        replace
      />
    );
  }

  return <>{children}</>;
}
